import React from 'react';
import axios from 'axios';
const Form = (props) => {
  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(props.data);
    const data={
      shippingInfo:{
        address:event.target[3].value,
        city:event.target[4].value,
        state:event.target[5].value,
        phoneNo:event.target[1].value,
        zip:event.target[6].value,
        country:event.target[7].value
      },
      Name:event.target[0].value,
      phoneNo:event.target[1].value,
      email:event.target[2].value,
      orderItem:{
        name:props.data.name,
        image:props.data.images[0]
      },
      Price:props.data.price,
      }
      console.log(data);
      axios.post(`${process.env.REACT_APP_BASE}/order/new`, data)
    .then((response) => {
      console.log('Response:', response);
      alert('Order Placed');
      props.toggleModal();
    })
    .catch((error) => {
      console.error('Error:', error);
      alert('Order not placed');
    });
  }
  return (
    <div className="h-40 fixed inset-0 my-72 flex items-center lg:justify-center z-50 rounded-lg">
      <div className="modal-overlay fixed inset-0 bg-black opacity-50"></div>
      <div className="modal-container bg-white w-10/12 md:max-w-md mx-auto rounded shadow-lg z-50 overflow-y-auto">
        <div className="modal-content py-4 text-left px-2 overflow-y-auto"> {/* Add overflow-y-auto */}
          <div className="flex justify-between items-center">
            <p className="text-xl mx-auto font-bold">Order Form</p>
            <button onClick={props.toggleModal} className="modal-close">
              <svg
                className="fill-current text-black"
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 18 18"
              >
                <path
                  d="M6.3 6l5.6 5.6m0-5.6L6.3 11.6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
          <div className="z-3 w-full md:w-96 md:max-w-full mx-auto bg-gray-300 rounded-md">
            <div className="px-2 py-1">
            <form
              onSubmit={handleSubmit}
              className='grid grid-rows-7'
              >
              <label class="block mb-6">
              <span class="text-gray-700">Your name</span>
              <input
              name="name"
              type="text"
              className="
                block
                w-full
        
                border-gray-300
                rounded-md
                shadow-md
                focus:border-indigo-300
                focus:ring
                focus:ring-indigo-200
                focus:ring-opacity-50
              "
              required
              />
              </label>
              <label class="block mb-6">
              <span class="text-gray-700">Phone Number(Eg : +91-83XXXXXX00)</span>
              <input
              name="telephone"
              type="Number"
              class="
                block
                w-full
        
                border-gray-300
                rounded-md
                shadow-md
                focus:border-indigo-300
                focus:ring
                focus:ring-indigo-200
                focus:ring-opacity-50
              "
              placeholder=""
              required/>
              </label>
              <label class="block mb-6">
              <span class="text-gray-700">E-mail (Will be used to Verify the Order) </span>
              <input
              name="telephone"
              type="email"
              class="
                block
                w-full

                border-gray-300
                rounded-md
                shadow-md
                focus:border-indigo-300
                focus:ring
                focus:ring-indigo-200
                focus:ring-opacity-50
              "
              placeholder=""
              required/>
              </label>
              <label class="block mb-6">
              <span class="text-gray-700">Address</span>
              <input
              name="address1"
              type="text"
              class="
                block
                w-full
                border-gray-300
                rounded-md
                shadow-md
                focus:border-indigo-300
                focus:ring
                focus:ring-indigo-200
                focus:ring-opacity-50
              "
              placeholder=""
              required/>
              </label>

              <label class="block mb-6">
              <span class="text-gray-700">City</span>
              <input
              name="city"
              type="text"
              class="
                block
                w-full
                border-gray-300
                rounded-md
                shadow-md
                focus:border-indigo-300
                focus:ring
                focus:ring-indigo-200
                focus:ring-opacity-50
              "
              placeholder=""
              required/>
              </label>
              <label class="block mb-6">
              <span class="text-gray-700">State/Province</span>
              <input
              name="state"
              type="text"
              class="
                block
                w-full
                border-gray-300
                rounded-md
                shadow-md
                focus:border-indigo-300
                focus:ring
                focus:ring-indigo-200
                focus:ring-opacity-50
              "
              placeholder=""
              required/>
              </label>
              <label class="block mb-6">
              <span class="text-gray-700">Zip/Postal code</span>
              <input
              name="zip"
              type="text"
              class="
                block
                w-full
                border-gray-300
                rounded-md
                shadow-md
                focus:border-indigo-300
                focus:ring
                focus:ring-indigo-200
                focus:ring-opacity-50
              "
              placeholder=""
              required/>
              </label>
              <label class="block mb-6">
              <span class="text-gray-700">Country</span>
              <input
              name="country"
              type="text"
              class="
                block
                w-full
                border-gray-300
                rounded-md
                shadow-md
                focus:border-indigo-300
                focus:ring
                focus:ring-indigo-200
                focus:ring-opacity-50
              "
              placeholder=""
              required/>
              </label>

              <div className="mb-6 ">
                <button
                  type="submit"
                  className="
                    h-10
                    w-20
                    px-5
                    text-indigo-100
                    bg-indigo-700
                    rounded-lg
                    transition-colors
                    duration-150
                    focus:shadow-outline
                    hover:bg-indigo-800
                  "
                >
                  Order
                </button>
              </div>
            </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Form;
